 <template>
	<section class='select_promo_module' v-if='show'>
		<transition name="fade">
			<div class="specs_cover" v-if="showPTChange"></div>
		</transition>
		<transition name="fadeBounce">
			<div class="specs_list" v-if="showPTChange">
				<header class="specs_list_header">
					<h4 class="ellipsis">{{product.name}}</h4>
					<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" class="specs_cancel" @click="showPromoCode(null)">
						<line x1="0" y1="0" x2="16" y2="16" stroke="#666" stroke-width="1.2" />
						<line x1="0" y1="16" x2="16" y2="0" stroke="#666" stroke-width="1.2" />
					</svg>
				</header>
				<div class="promoList" v-if='opType'>
					<div class="list select" v-for="(item,key) in listData" :key="key"  @click.stop='select(key)'>
						<span class="code">优惠码:{{key}}&nbsp;数量:{{item.num}}</span>
						<b>&nbsp;</b>
						<div class="del" @click.stop="delCode(key)"><img title="" src="@/assets/del.png" ></div>
					</div>
					
				</div>
				<template v-if='!opType'>
						<section class="specs_details promo_msg" v-if='msg'>
					<span class="specs_details_msg">{{msg}}</span>
				</section>
				<section class="section_list">
					<span class="section_left ">优惠码(PromoCode)</span>
					<section class="section_right">
						<div class="phone_add">
							<input v-model="code" name="moblie_phone" placeholder="请输入兑换码(Input PromoCode)" maxlength="20" :disabled='model' class="input_style">
							<!-- <div>&nbsp;</div>
							<div class="phone_add_check" :class="'check_'+styleState" @click="checkCode">{{outputText(confirmText)}}</div> -->
						</div>
					</section>
				</section>
				<section class="section_list" v-if='model'>
					<span class="section_left ">购买数量(Buy Quantity)：</span>
					<section class="section_right">
						<div class="phone_add">
							<input type="tel" :disabled='number==1' v-model="num" name="moblie_phone" placeholder="请输入本次购买数量(Input Buy Quantity)" maxlength="6" class="input_style">
						</div>
					</section>
				</section>

				<footer class="specs_footer">
					<div class="specs_price">
						<span>剩余数量(Residual Quantity)：</span>
						<span>{{number}}</span>
					</div>
						<div class="specs_addto_cart" :class="'check_'+styleState" @click="showPromoCode(1)">{{confirmText}}</div>
				</footer>

				</template>
				<!-- <span class="promo_msg">2323232</span> -->
			
				<!-- <section class="specs_details">
	                       <h5 class="specs_details_title" style="float:none;"></h5>
	                    </section> -->
				<template v-if='opType'>
					<footer class="specs_footer">
					<div class="specs_price"></div>
					<div class="right">
						<div class="specs_addto_cart" :class="'check_'+3" @click="confirm(1)">确认(Confirm)</div>
					</div>
				</footer>
				</template>
				
			</div>
		</transition>
	</section>
</template>

<script>
import { mapState, mapMutations, mapGetters,mapActions  } from "vuex";
import { api_methods } from "@/service/loadData";
import {
	systemConfigMethods,
	cartInfoMethods,
	userInfoOrderMethods,
	promoCodeMethods,
	purchaseEventMethods,
} from "@/components/common/mixin";
export default {
	data() {
		return {
			choosedProducts: null, //当前选中视频数据
			showPTChange: true, //控制显示PT兑换小窗口
			confirmText: "验证(Check)",
			msg: null,
			code: null,
			num: null,
			disable: false,
			number: 0,
			model: null,
			selectCode:null,
			//定义状态号
			styleState: 1,
			listData:{},
			mobileMode:false,
		};
	},
	mixins: [userInfoOrderMethods, cartInfoMethods, promoCodeMethods,purchaseEventMethods],
	props: ["product", "show",'opType'],
	mounted() {},
	computed: {
		...mapGetters(["getUserId", "getAccessToken", "getVipNo"]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			cartInfo: state => state.order.cartInfo,
			newpromoCode: state => state.order.newpromoCode,
			purchaseEvent:(state)=> state.order.purchaseEvent,
		}),
		MaxNum: function() {
			if (this.product.promo_flag == 1) {
				let promolists = this.product.promolists[0] || {};
				if (promolists.max_num > 0) {
					return (
						"(每个代码可购买" +
						promolists.max_num +
						"套)(Max Buy PromoCode " +
						promolists.max_num +
						")"
					);
				}
			}
			return "";
		},
	},
	created() {
			this.$nextTick(function () {
			if (document.documentElement.clientWidth < 1090) {
				this.mobileMode = true;
			}
		});
	},
	methods: {
		...mapActions(["updateCartAction",'saveCartAction']),
		...mapMutations(["SET_NEWPROMOCODE",'SET_NEWPROMOCODEALL', "CLEAR_CART", "ADD_CART",'EDIT_CART1','SET_CART_TOTAL']),
		showReduceTip() {
			this.$emit("showReduceTip");
		},
		setCar(remark, promo_code,product_number) {
			var category_id = this.product.category_id;
			var item_id = this.product.item_id;
			var product_id = this.product.specproducts[0].product_id;
			var name = this.product.specproducts[0].name;
			var rt_price = this.product.specproducts[0].original_price;
			var pc_price = this.product.specproducts[0].price;
			var price = this.isPVOriginalPrice
				? this.product.specproducts[0].original_price
				: this.product.specproducts[0].price;
			var pv = this.product.specproducts[0].pv;
			var pt = this.product.specproducts[0].pt;
			var specs = "";
			var packing_fee = this.product.specproducts[0].packing_fee;
			var sku_id = this.product.specproducts[0].sku_id;
			var sku = this.product.sku;
			var stock = this.product.specproducts[0].stock;
			var is_promotion = this.product.is_promotion;
			var is_new = this.product.is_new;
			

			this.ADD_CART({
				category_id,
				item_id,
				product_id,
				name,
				price,
				rt_price,
				pc_price,
				pv,
				pt,
				specs,
				packing_fee,
				sku_id,
				sku,
				stock,
				is_promotion,
				is_new,
				product_number,
				promo_code,
				remark
			});
		},
		async check() {
			if (!this.code || this.code.length < 6) {
				this.msg = "优惠码无效(PromoCode invalid)";
				return -1;
			}
			var vipno = this.getVipNo;
			if (this.forCustomer) {
				vipno = this.forCustomer.vipno;
			}
			var sku = this.product.sku;
			var res = await api_methods.checkPromoCode(
				this.getAccessToken,
				this.getUserId,
				vipno,
				this.code,
				sku
			);

			if (res && res.response && res.response.code == "1") {
				if (res.data.value.v.code > 0) {
					var data=res.data.value.v.data[0]
					if (data.exchange_quantity <= 1) {
						this.disable = true;
						this.num = 1;
					} else {
						this.disable = false;
						if(this.listData[data.promo_code]){
					 	  this.num=this.listData[data.promo_code].num
						}
						else{
							this.num = null;
						}
					}
					return data;
				} else {
					this.msg = "优惠代码不正确(PromoCode Incorrect)";
					return -1;
				}
			} else {
				this.msg = res.response.message;
				return -1;
			}
		},
		outputText(str){
			if(this.mobileMode){
				return str.split('(')[0]
			}
			return str
		},
		addCode(){
			//保存当前选项
			this.saveSelfCode();
			
			this.confirmText = "验证(Check)";
			this.msg = null;
			this.model = null;
			this.code = null;
			this.selectCode=null;
			this.number = 0;
		
		},
		claerData(){
			this.confirmText = "验证(Check)";
			this.msg = null;
			this.model = null;
			this.number = 0;
			this.code = null;
			this.selectCode=null;
		},
		async checkCode(){
			if (this.confirmText == "验证(Check)") {
				this.confirmText = "正在验证中(Load)";
				//await this.sleep(2000)
				var result = await this.check();
				if (result == -1) {
					this.confirmText = "验证(Check)";
					return false;
				}

				this.msg = null;
				
				if(this.listData[result.promo_code]){
					result.num=this.listData[result.promo_code].num
					this.num=result.num;
				}
				this.model = Object.assign({}, result);
				this.listData[result.promo_code]=result;
				this.selectCode=result.promo_code;
			
				this.number = this.model.exchange_quantity;
				this.confirmText = "验证(Check)";
				return true;
			}
		},

		confirm(type){
			
			var sku=this.product.sku;
			var listData=this.listData;
			var obj=[]
		 	var promo_code=''
			var product_number=0
			var str=''

			Object.values(listData).forEach(item=>{
					obj.push({
						sku:item.exchange_sku,
						code:item.promo_code,
						num:item.num
					})
					promo_code+=item.promo_code+','
					product_number+=item.num
			})

			
			if(promo_code!=''){
				promo_code=promo_code.substring(0,promo_code.length-1);
			}

			var json=JSON.stringify(obj)
			this.SET_NEWPROMOCODE({item:listData,sku})
			if(promo_code!=''){
				if(this.shopCart.find(item=>item.sku == sku)) {
					this.EDIT_CART1({ sku,num:product_number,promo_code,remark:json });
				} else {
					this.setCar(json,promo_code,product_number)
				}
			} else {
				this.EDIT_CART1({ sku,num:0});
			}
			this.updateCart(sku,promo_code,product_number,json)
			if(type==1){
				this.showPromoCode(false);
			}
			return true

		},

		// async confirm(){
		// 	//全部保存
		// 	//验证
		// 	this.msg=null;
		// 	var str=''
		// 	var sku=this.product.sku
		// 	var listData=this.listData;
		// 	var obj=[]
		// 	var promo_code=''
		// 	var product_number=0

		// 	this.saveSelfCode();
		// 	if(!this.listData[this.selectCode]){
		// 		this.EDIT_CART1({ sku,num:0 });
		// 		this.SET_NEWPROMOCODE({item:listData,sku})
		// 		this.updateCart(sku,promo_code,product_number,'')
		// 		this.showPromoCode(false);
		// 		return 
		// 	} 
		
		// 	Object.values(listData).forEach(item=>{
		// 		if(!item.num||item.num>item.exchange_quantity){
		// 			str=str+item.promo_code+','
		// 		}
		// 		else{
		// 			obj.push({
		// 				sku:item.exchange_sku,
		// 				code:item.promo_code,
		// 				num:item.num
		// 			})
		// 			promo_code+=item.promo_code+','
		// 			product_number+=item.num
		// 		}
		// 	})
		// 	if(str!=''){
		// 		this.msg=str.substring(0,str.length-1)+'超出优惠码最大限制'
		// 		return false
		// 	}
		// 	if(promo_code!=''){
		// 		promo_code=promo_code.substring(0,promo_code.length-1);
		// 	}
		// 	var json=JSON.stringify(obj)
		// 	this.EDIT_CART1({ sku,num:0 });
		// 	this.setCar(json,promo_code,product_number)   //设置缓存
		// 	this.SET_NEWPROMOCODE({item:listData,sku})
		// 	this.updateCart(sku,promo_code,product_number,json)
		// 	this.showPromoCode(false);
		// },
		async showPromoCode(type) {
			if (type) {
				//点击确定
				if (this.confirmText == "确认(Confirm)") {
					var codeNum = Number(this.num);
                    if (!(/^\+?[1-9][0-9]*$/).test(codeNum)) {
						this.msg = "输入优惠码数量不正确";
						return false;
					}
					if (codeNum > this.model.exchange_quantity) {
						this.msg =
							"超出优惠码最大限制(Beyond PromoCode Max Limit)";
						return false;
					}
					var _model = Object.assign({}, this.model);
					if (_model.mix_flag == 2) {
						this.CLEAR_CART();
					}
					if (_model.mix_flag == 1 && !this.firstPromoCode) {
						this.CLEAR_CART();
					}

					_model.num=codeNum
					this.listData[_model.promo_code]=_model;

					if(!this.confirm()) return false

					//this.CLEAR_CART()
					//this.setCar(codeNum, _model.promo_code);
                    //this.SET_NEWPROMOCODE(_model);
					
					//this.updateCart(_model.exchange_sku,_model.promo_code,codeNum)
                    
					this.confirmText = "验证(Check)";
				} else if (this.confirmText == "验证(Check)") {
					this.confirmText = "正在验证中(Load)";
					var result = await this.check();
					if (result == -1) {
						this.confirmText = "验证(Check)";
						return false;
					}
					
					this.msg = null;
					this.model = Object.assign({}, result);
					this.number = this.model.exchange_quantity;
					this.confirmText = "确认(Confirm)"
					return false;
				} else {
					return false;
				}
			} else {
			 	
			}
			this.$emit("showPromoCode");
		},
		updateCart(sku,code,num,remark) {
			if (this.needSaveTotalCart(sku,num)) return
			var params = {
				//customerId:this.getUserId,
				sku,
				num,
				code,
				remark
			};
			this.updateCartAction(params);
		},
		getCodeData(code){
			var item=this.listData[code]
			this.code=code
			if(item){
				this.number=item.exchange_quantity
				this.num=item.num
				this.model=item;
			}
			else{
				this.number = 0;
				this.num = 0;
				this.model={};
			}
			
		},
		select(code){
			if(this.selectCode){
				if(this.selectCode==code){
					return 
				}
				this.saveSelfCode()

			}
			this.selectCode=code
			this.getCodeData(code)
		},
		saveSelfCode(){
			if(this.selectCode){
				var codeNum = Number(this.num);
				if (!(/^\+?[1-9][0-9]*$/).test(codeNum)) {
					codeNum=1
				}
				if(this.listData[this.selectCode]){
					this.listData[this.selectCode].num=codeNum
				}
			
			}
		},
		delCode(code){
			var listData={}
			var selfCode=null
			Object.values(this.listData).forEach((item,index)=>{
				if(item.promo_code!=code){
					if(!selfCode) selfCode=item.promo_code
					listData[item.promo_code]=item;
				}
			})
			this.claerData()
			if(selfCode){
				this.selectCode=selfCode
				this.getCodeData(selfCode)
			}
			this.listData=listData;
		},
		initData(){
			var sku=this.product.sku;
			this.listData= Object.assign({}, this.getBySkuPromoCode(sku));

			// Object.values(this.listData).forEach((item,index)=>{
			// 	if(index==0){
			// 		this.selectCode=item.promo_code
			// 	}
			// })

			//this.selectCode=(this.firstPromoCode||{}).promo_code

		}
	},
	watch: {
		show: function(value) {
			if (value) {
				this.claerData()
				this.listData={}
				this.initData()
			}
			else{
				
			}
		},
		confirmText: function(value) {
			if (value == "确认(Confirm)") {
				this.styleState = 3;
			} else if (value == "正在验证中(Load)") {
				this.styleState = 2;
			} else {
				this.styleState = 1;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/style/mixin";
@import "@/style/common";

.promoList{
	padding: 11.72px;
	
	width: 100%;
	.list{
		border: 1px solid #d1cdd2;
		display:inline-block;
		//position: relative;
		border-radius: 5px;
		cursor: pointer;
		&.select{
			border: 1px solid $theme-color;
			.code{
				color:$theme-color;
			}
		}
		overflow: hidden;
		margin-right: 10px;
	}
	.code{
		@include fontSize($font-size-14);
		padding: 2px;
		display: inline-block;
		color:#d1cdd2;
		padding-right: 5px;
	}
	b{
		//position: absolute;
		width: 1px;
		height: 200%;
		
		background-color: #ded2d2;
		display: inline-block;
	}
	.del{
		margin: 0 5px;
		display: inline-block;
		width: 10px;
		img{
			width: 100%;
		}
	}
}

.select_promo_module {
	.add_icon {
		position: relative;
		z-index: 999;
		margin: 5.86px;
	}
	.cart_button {
		display: flex;
		align-items: center;
		input:disabled {
			border: 1px solid #ddd;
			background-color: #f5f5f5;
			color: #aca899;
		}
	}
	svg {
		@include wh(21.09px, 21.09px);
		fill: #3190e8;
	}
	.specs_reduce_icon {
		fill: #999;
	}
	.cart_num {
		@include sc(15.23px, #666);
		min-width: 23.44px;
		text-align: center;
		font-family: Helvetica Neue, Tahoma;
		input {
			width: 35.16px;
			border: 1px #ddd solid;
			padding: 2.34px;
			margin: 4.69px;
		}
	}
	.choose_specification {
		.choose_icon_container {
			display: flex;
			align-items: center;
			.show_chooselist {
				display: block;
				@include sc(12.89px, #fff);
				padding: 2.34px 4.69px;
				background-color: $green;
				border-radius: 4.69px;
				border: 1px solid $green;
			}
		}
	}
}
.showReduce-enter-active,
.showReduce-leave-active {
	transition: all 0.3s ease-out;
}
.showReduce-enter,
.showReduce-leave-active {
	opacity: 0;
	transform: translateX(23.44px);
}
.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s;
}
.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.fadeBounce-enter-active,
.fadeBounce-leave-active {
	transition: all 0.3s;
}
.fadeBounce-enter,
.fadeBounce-leave-active {
	opacity: 0;
	transform: scale(0.7);
}

.specs_cover {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: 10000;
}
.specs_list {
	position: fixed;
	top: 35%;
	left: calc(50% - 320px);
	width: 640px;
	padding: 25px;
	background-color: #fff;
	z-index: 10001;
	border: 1px;
	border-radius: 4.69px;
	overflow: hidden;
	.specs_list_header {
		h4 {
			@include sc(16.41px, #222);
			font-weight: normal;
			text-align: center;
			padding: 11.72px;
		}
		.specs_cancel {
			position: absolute;
			right: 11.72px;
			top: 11.72px;
		}
	}
	.specs_details {
		padding: 2.34px 11.72px 11.72px 11.72px;
		.specs_details_title {
			@include sc(14.06px, #666);
			margin: 5.86px 0 0 2.34px;
			float: left;
		}
		.specs_details_msg {
			@include sc(14.06px, #666);
			padding: 0;
			color: red;
			font-weight: 500;
		}
		&.promo_msg {
			padding: 0 0 0 11.72px;
			color: red;
		}
		ul {
			margin: 4.69px 0 0 2.34px;
			display: flex;
			flex-wrap: wrap;
			padding: 0px 0;
			li {
				font-size: 14.06px;
				padding: 7.03px 11.72px;
				border: 0.59px solid #ddd;
				border-radius: 4.69px;
				margin-right: 11.72px;
			}
			.specs_activity {
				border-color: #3199e8;
				color: #3199e8;
			}
		}
	}
	.specs_footer {
		@include fj;
		align-items: center;
		background-color: #f9f9f9;
		padding: 11.72px;
		border: 1px;
		border-bottom-left-radius: 4.69px;
		border-bottom-right-radius: 4.69px;
		.specs_price {
			span {
				color: #ff6000;
			}
			span:nth-of-type(1) {
				font-size: 11.72px;
			}
			span:nth-of-type(2) {
				font-size: 18.75px;
				font-weight: bold;
				font-family: Helvetica Neue, Tahoma;
			}
		}
		.specs_addto_cart {
			@include wh(93.75px, 30.47px);
			background-color: #3199e8;
			border: 1px;
			cursor: pointer;
			border-radius: 3.52px;
			@include sc(14.06px, #fff);
			text-align: center;
			line-height: 30.47px;
			&.check_1 {
				background-color: #e25454;
			}
			&.check_2 {
				background-color: #ddd;
			}
			&.check_3 {
				background-color: #3199e8;
			}
			&.check_4 {
				background-color: $theme-color;;
			}
		}
		.right{
			display: flex;
			flex-direction: row;
			
		}
	}
	.section_list {
		padding: 11.72px;
		@include sc(14.06px, #666);
		display: flex;
		border-bottom: 0.59px solid #f5f5f5;
		display: inherit;
		.section_left {
			@include sc(11.72px, #333);
			flex: 3;
			line-height: 35.16px;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.section_right {
			flex: 4;
			.input_style {
				width: 100%;
				height: 35.16px;
				@include sc(11.72px, #999);
			}
		}
		.phone_add{
			display: flex;
		}
		.phone_add_check{
			background-color: #3199e8;
			border: 1px;
			cursor: pointer;
			border-radius: 0px;
			@include fontSize($font-size-13);
			color: white;
			display: inline-block;
			text-align: center;
			padding: 0 5px;
			line-height:35.16px;
			width: 97px;
			&.check_1 {
				background-color: #e25454;
			}
			&.check_2 {
				background-color: #ddd;
				width: 128px;
			}
			&.check_3 {
				background-color: #3199e8;
			}
			&.check_4 {
				background-color: $theme-color;;
			}
		}
	}
}
@media screen and (max-width: 1090px) {
	.specs_list {
		width: 95%;
		left: 2.5%;
		right: 2.5%;
	}
}
</style>

